import VueI18n from 'vue-i18n';
import { path } from 'ramda';
import french from '../i18n/locales/fr.json';
import english from '../i18n/locales/en.json';
import russian from '../i18n/locales/ru.json';
import georgian from '../i18n/locales/ka.json';
import arabic from '../i18n/locales/ar.json';
import turkish from '../i18n/locales/tr.json';
import macedonian from '../i18n/locales/mk.json';

const langs = [
  'english', 'french', 'russian', 'georgian', 'arabic', 'turkish', 'macedonian'
];

const aliaces = {
  fr: 'french',
  en: 'english',
  ru: 'russian', 
  ka: 'georgian', 
  ar: 'arabic', 
  tr: 'turkish', 
  mk: 'macedonian'
}

export const checkLang = lang => {
  if (langs.includes(lang)) {
    return lang;
  }
  if (langs.includes(aliaces[lang])) {
    return aliaces[lang];
  }
  return 'english';
};

class TranslateService {
  getAll(locale) {
    this.i18n = new VueI18n({
      locale: checkLang(locale), // set locale
      messages: {
        english,
        french,
        russian,
        georgian,
        arabic,
        turkish,
        macedonian
      }
    });
    return Promise.resolve(this.i18n);
  }

  t(key) {
    return path(key.split('.'), this.i18n.messages[this.i18n.locale]);
  }
}

export default new TranslateService();
